import React from 'react';
import styled from 'styled-components';

import { Tooltip } from 'components'

const defaultStyle = {
    backgroundColor: 'var(--secondary-accent-color)',
    barColor: 'var(--primary-color)',
    fontSize: '0.8rem',
    width: null,
    height: null,
    margin: 0,
}

const Aux = styled.div`
    // width: 100%;
    /* height: 100%; */
    margin: ${props => props.styles.margin};
`

const Container = styled.div`
    min-height: 0.1rem;
    background-color: ${props => props.styles.backgroundColor};
    width: ${props => props.orientation === 'horizontal' && props.styles.width ? props.styles.width
            : props.orientation === 'horizontal' ? '100%' 
            : props.orientation === 'vertical' && props.styles.width ? props.styles.width
            : '0.2rem'}; 
    height: ${props => props.orientation === 'vertical' && props.styles.height ? props.styles.height
            : props.orientation === 'vertical' ? '100%'
            : props.orientation === 'horizontal' && props.styles.height ? props.styles.height
            : '0.2rem'};
    margin: ${props => props.styles.margin};
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    cursor: pointer;
`

const Bar = styled.div`
    min-height: 0.1rem;
    background-color: ${props => props.styles.barColor};
    width: ${props => props.orientation === 'horizontal' && props.percent ? props.percent 
            : props.orientation === 'horizontal' && !props.percent ? '0' 
            : props.orientation === 'vertical' && props.styles.width ? props.styles.width 
            : '0.2rem'}; 
    height: ${props => props.orientation === 'vertical' && props.percent ? props.percent 
            : props.orientation === 'vertical' && !props.percent ? '0' 
            : props.orientation === 'horizontal' && props.styles.height ? props.styles.height 
            : '0.2rem'};
    border-radius: 2px;
    display: flex;
    flex-direction: ${props => props.orientation === 'vertical' ? 'column' : 'row'};
    justify-content: flex-end;
    align-items: flex-end;
`

const LabelContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
`

const Label = styled.div`
    font-weight: ${props => props.styles.fontWeight};
    font-size: 0.8rem;
`

const PercentBar = props => {
    const {
        orientation,
        value,
        percent,
        label,
        styles,
        tooltip,
        onSelect
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)

    const content = 
    <Container orientation={orientation} styles={updatedStyle} onClick={onSelect}>
            <Bar orientation={orientation} percent={percent} styles={updatedStyle}/>
        </Container>
    return (
        <Aux styles={updatedStyle}>
            <LabelContainer>
                {label && <Label styles={{fontWeight: 'bold'}}>{label}</Label>}
                {value && <Label styles={{fontWeight: 'normal', left: '100%'}}>{value}</Label>}
            </LabelContainer>
            {tooltip ? <Tooltip title={tooltip} arrow={true}>{content}</Tooltip> : content}
        </Aux>
    )
}

export default PercentBar;
